export class DtoGeneralCodigoNombreUnidad {
    Codigo: string = ''
    Nombre: string = ''
    UnidadMedida: string = ''
}